/* eslint-disable react-hooks/exhaustive-deps */
// @ts-ignore - CSS imports are handled by the project build tooling, not TS declarations.
import './sumary.scss';
import { Grid } from '@mui/material';
import React from 'react';
import { useAppDispatch } from 'app/hooks'; 
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import counselorServices from 'services/counselorServices';
import FamilySum from './components/FamilySum';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

const ReviewFamily = () => {
  const dispatch:any = useAppDispatch();
  const history = useHistory();  
  let studentId = getUserId();
  let token = getAccessToken();
  const [listCounselorConnection, setListCounselorConnection] = React.useState<any[]>([]);
  const [currentModuleId, setCurrentModuleId] = React.useState('2.1');

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const getData = () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      counselorServices.getCounselors(studentId).then((res: any[]) => {
        setListCounselorConnection(res ?? []);
      });      
    }
    else {
      handleLogout();
    }
  }

  React.useEffect(() => {
    getData();
    console.log('currentModuleId:', currentModuleId);
    console.log('listCounselorConnection:', listCounselorConnection);    
  }, []);

  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid item xs={12} md={8}>
        <FamilySum setCurrentModuleId={setCurrentModuleId} />
      </Grid>
      {/* <Grid item xs={12} md={4} sx={{ marginTop: { md: '48px' } }}>
        {listCounselorConnection.map((item, index) => (
          <ConversationCard conversationItem={item} currentModuleId={currentModuleId} key={index} />
        ))}
      </Grid> */}
    </Grid>
  );
};

export default ReviewFamily;
